import { useIsFocused } from '@react-navigation/native'
import { useCallback, useEffect, useMemo } from 'react'

import { useFilters } from './useFilters'

import { useGetOffers } from '~query-hooks'

export const useGetFilteredOffers = ({ enabled = true } = {}) => {
  const isFocused = useIsFocused()

  const { filtersState } = useFilters()

  const { categoriesList, selectedLocation, selectedOfferStatus, coinRange } = filtersState

  const valuesOfSelectedCategories = useMemo(() => {
    return categoriesList.filter(({ isChecked }) => isChecked).map(({ value }) => value)
  }, [categoriesList])

  const {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoadingOffers,
    isRefetchingOffers,
    offers,
    refetchOffers,
  } = useGetOffers(
    {
      //HACK: Remove this when BE fix coinRange filtration
      fromCoin: +coinRange.from ? +coinRange.from : +coinRange.to ? 0 : undefined,
      toCoin: +coinRange.to ? +coinRange.to : +coinRange.from ? 99999999 : undefined,
      isRedeemed: selectedOfferStatus.value ? +selectedOfferStatus.value : undefined,
      categoryId: valuesOfSelectedCategories.length ? valuesOfSelectedCategories : undefined,
      locations: selectedLocation.value ? [selectedLocation.value] : undefined,
    },
    {
      enabled,
    }
  )

  const refetchUserData = useCallback(async () => {
    await refetchOffers()
  }, [refetchOffers])

  useEffect(() => {
    if (isFocused && enabled) {
      refetchUserData()
    }
  }, [enabled, isFocused, refetchOffers, refetchUserData])

  return {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoadingOffers,
    isRefetchingOffers,
    offers,
    refetchOffers,
  }
}
